import { render, staticRenderFns } from "./SidebarItem2.vue?vue&type=template&id=2dbd4ff5&scoped=true&"
import script from "./SidebarItem2.vue?vue&type=script&lang=js&"
export * from "./SidebarItem2.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItem2.vue?vue&type=style&index=0&id=2dbd4ff5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd4ff5",
  null
  
)

export default component.exports